/** @module Specification/BOM/AggregateSizeSpecController */
define([
	"dojo/_base/declare",
	"csi/heading/_AggregateWithNewMixin",
	"csi/heading/AggregateController",
	"csi/locale"
], function(declare,_AggregateWithNewMixin,AggregateController,locale) {

	return declare([AggregateController,_AggregateWithNewMixin], {
		aggregateNewNodeType: "SizeSpec",

		/**
		 * Allow custom error handling for New action
		 * @param {Controller} ac
		 * @param {Exception} err
		 */
		onNewError: function(ac, err) {
			if (err.csiErrorException && err.csiErrorException.includes("No edit access")) {
				ac.m_error = locale.resource("AggregateCommonSizeSpecEditAccess_Error");
				ac._errorCode = "";
			}
		}
    });
});